import { getTimeString } from '../../../../backend/utils/getTimeString';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
export const VolunteeringHours = ({ hoursStatus, hours }) => {
    const { t } = useMissionsTranslation();
    let hoursContent;
    if (hours) {
        hoursContent = t(`time`, { value: getTimeString(hours) });
    }
    else {
        if (hoursStatus === 'deniedNoShow') {
            hoursContent = '-';
        }
        else {
            hoursContent = t('timeTracking.missingHoursTable');
        }
    }
    return (React.createElement(Box, { display: 'flex', gap: 0.5, sx: { color: hoursStatus === 'deniedInaccurate' ? themeColors.decorative.orange : undefined } },
        React.createElement(Typography, { variant: 'body2', sx: {
                wordBreak: 'break-word',
            } }, hoursContent),
        hoursStatus === 'deniedInaccurate' && (React.createElement(Box, { display: 'flex', gap: 0.5 },
            React.createElement(Typography, { variant: 'subtitle2' }, t('common.denied')),
            React.createElement(Tooltip, { title: t('timeTracking.deniedTooltipText') },
                React.createElement(InfoOutlinedIcon, { sx: { color: themeColors.text.subtle }, fontSize: 'small' }))))));
};
